<template>
	<lcsj-dialog v-model="showDialog" ref="processWareHouseHistoryDialog" :title="'库存流水 - ' + (goodsName || '')" width="85%" append-to-body @close="closeDialog" cancel-text="关闭">
		<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="变动类型：">
				<el-select v-model.number="formInline.changeType" placeholder="请选择变动类型" size="small" @change="search">
					<el-option label="全部" :value="0"></el-option>
					<el-option v-for="item in changeTypeList" :key="item.code" :label="item.name" :value="Number(item.code)"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="来源单号：">
				<el-input clearable v-model="formInline.sourceNo" size="small" placeholder="请输入来源单号" @keyup.enter.native="inputChange"></el-input>
			</el-form-item>
			<el-form-item label="变动时间：">
				<el-date-picker
					v-model="dateValue"
					clearable
					size="small"
					type="daterange"
					value-format="yyyy-MM-dd"
					format="yyyy-MM-dd"
					range-separator="~"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					@change="handleDateChange"
				></el-date-picker>
			</el-form-item>
			</lcsj-filter>
		<STable :columns="columnsData" :data="listData" :loading="loading" border height="420" @get-data="getListData">
			<template #changeQuantity>
				<el-table-column align="center" label="变更量" width="100">
					<template #default="scope">
						<span :class="scope.row.changeQuantity >= 0 ? 'text-success' : 'text-danger'">
							{{ scope.row.changeQuantity >= 0 ? "+" + scope.row.changeQuantity : scope.row.changeQuantity }}
						</span>
					</template>
				</el-table-column>
			</template>
		</STable>
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		
	</lcsj-dialog>
</template>

<script>
import { GetProcessWareHouseHistoryPageList } from "@/api/processApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
export default {
	data() {
		return {
			showDialog: false,
			goodsKeyId: "",
			goodsName: "",
			pageShow: true,
			loading: false,
			listData: [],
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			dateValue: [],
			changeTypeList: [],
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				goodsKeyId: "",
				changeType: 0,
				sourceNo: "",
				startTime: null,
				endTime: null
			},
			columnsData: [],
			listColumns: [
				{ prop: "rowNumber", label: "序号", align: "center", width: "70", isKeep: true },
				{ prop: "goodsTypeName", label: "商品品牌", align: "center", width: "140" },
				{ prop: "goodsName", label: "商品名称", align: "center", minWidth: "180" },
				{ prop: "qiuJing", label: "球镜", align: "center", width: "80" },
				{ prop: "zhuJing", label: "柱镜", align: "center", width: "80" },
				{ prop: "changeTypeStr", label: "变动类型", align: "center", width: "120" },
				{ prop: "sourceNo", label: "来源单号", align: "center", width: "220" },
				{ prop: "yuanQuantity", label: "变更前", align: "center", width: "90" },
				{ slot: "changeQuantity", label: "变更量", align: "center", width: "100" },
				{ prop: "xianQuantity", label: "变更后", align: "center", width: "90" },
				{ prop: "remark", label: "备注", align: "center", minWidth: "140" },
				{ prop: "creator", label: "操作人", align: "center", width: "100" },
				{ prop: "createTime", label: "操作时间", align: "center", width: "170" }
			]
		};
	},
	created() {
		this.getCheckBox(this.listColumns.map((item) => item.label));
		GetEnumConfigListByCode({ code: "ProcessChangeType" })
			.then((res) => {
				if (res.code == 1) {
					this.changeTypeList = res.data || [];
				}
			})
			.catch(() => {});
	},
	methods: {
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		showHistoryDialog(row) {
			this.goodsKeyId = row.goodsKeyId;
			this.goodsName = row.goodsName || row.goodsTypeName || "";
			this.formInline.goodsKeyId = row.goodsKeyId;
			this.showDialog = true;
			this.search();
		},
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
			this.search();
		},
		// 后端 int 型筛选字段不接受 null/空串（System.Text.Json 会直接返回 400），统一归一化为 0（0=不筛选）
		normalizeQuery() {
			["changeType"].forEach((key) => {
				const val = this.formInline[key];
				if (val === null || val === undefined || val === "") this.formInline[key] = 0;
			});
		},
		getListData() {
			this.normalizeQuery();
			this.loading = true;
			GetProcessWareHouseHistoryPageList(this.formInline)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.listData = res.data || [];
						this.pageparm.total = res.totalNumber;
					} else {
						this.listData = [];
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		clearAll() {
			const goodsKeyId = this.goodsKeyId;
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.formInline.goodsKeyId = goodsKeyId;
			this.dateValue = [];
			this.search();
		},
		inputChange() {
			this.search();
		},
		callFather(parm) {
			this.formInline.pageIndex = parm.currentPage == undefined ? 1 : parm.currentPage;
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		closeDialog() {
			this.showDialog = false;
			this.listData = [];
			this.goodsKeyId = "";
			this.goodsName = "";
			this.dateValue = [];
			this.$data.formInline = this.$options.data.call(this).formInline;
		}
	}
};
</script>

<style scoped>
.text-danger {
	color: var(--app-danger);
}
.text-success {
	color: var(--app-success);
}
</style>
